<template>
  <Card :bordered='false' class='border-radius-0'>
    <CTable
        :isLoading='isLoading'
        v-model:columns='mapperState.columns'
        v-model:page='mapperState.page'
        :options='mapperState.tableOptions'
        :manages='mapperState.manages'
        :manageExtras='mapperState.manageExtras'
        :rowActions='mapperState.rowActions'
        :clientSide='true'
        :canRefresh='false'
        :ref='(e) => (refs.table = e)'
        :visibleSearch="false"
    ></CTable>
  </Card>
</template>

<script>
import {defineAsyncComponent, defineComponent, reactive} from 'vue';
import {Card} from 'ant-design-vue';
import {state as stateApp} from '../../../../../app.logic';
import {initMapperState, isLoading, mapperState} from "./lab-monitor-product-group-topic-managment.logic";

export default defineComponent({
  components: {
    Card,
    CTable: defineAsyncComponent(() => import('../../../../../components/table/CTable')),
  },
  props: {
    menuContext: {default: () => stateApp.menuContext },
    viewOnly: {},
    record: {},
  },
  setup(props) {
    const refs = reactive({table: {}})
    initMapperState({props});
    return {isLoading, mapperState, refs};
  },
})
</script>
